<template>
  <v-row>

  <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">

          <v-col class="pl-4 mb-8" cols="12">
            <h3 class="font-weight-regular">Secciones:</h3>
          </v-col>

          <v-col cols="12" v-show="false">
            <v-progress-linear
              color="primary"
              height="28"
              :value="customization.progress"
            >
            <h5 class="white--text">Progreso de la personalización: {{ customization.progress }}%</h5>
            </v-progress-linear>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationMainSection' }"
              >
              Sección principal
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationFeaturedSponsorsSection' }"
              >
              Sección Patrocinadores
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationAuthSection' }"
              >
              Sección Registro/login
            </v-btn>
          </v-col>
          
          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationTextSection' }"
              >
              Sección Texto
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationIndicatorsSection' }"
              >
              Sección Indicadores
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationFeaturedEntrepreneurshipsSection' }"
              >
              Sección Emprendimientos
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              :to="{ name: 'customizationContactSection' }"
              >
              Sección Contacto
            </v-btn>
          </v-col>

          <v-col cols="12" xl="6" md="6" sm="12">
            <v-btn
              color="primary"
              block
              large
              disabled
              >
              Sección transmisión en vivo
            </v-btn>
          </v-col>


        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'customizationLanding',
    data: () => ({
      loading:false,
      loading_update: false,
      edition_id:null,
      edition:[],
      customization:[],

      home_image: null,
      url_home_image: null,

      appbar_image: null,
      url_appbar_image: null,
      appbar_dark_mode: 1,

      auditorium_image: null,
      url_auditorium_image: null,

      auditorium_image_sm: null,
      url_auditorium_image_sm: null,

      my_project_image: null,
      url_my_project_image: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.edition = response.data.data
          this.customization = response.data.data.customization

          this.home_image = response.data.data.customization.home_image
          this.url_home_image = APP_URL+ this.home_image
          
          this.appbar_image = response.data.data.customization.appbar_image
          this.url_appbar_image = APP_URL+ this.appbar_image
          this.appbar_dark_mode = response.data.data.customization.appbar_dark_mode

          this.auditorium_image = response.data.data.customization.auditorium_image
          this.url_auditorium_image = APP_URL+ this.auditorium_image

          this.auditorium_image_sm = response.data.data.customization.auditorium_image_sm
          this.url_auditorium_image_sm = APP_URL+ this.auditorium_image_sm

          this.my_project_image = response.data.data.customization.my_project_image
          this.url_my_project_image = APP_URL+ this.my_project_image

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('home_image', this.home_image)
        formData.append('appbar_image', this.appbar_image)
        formData.append('appbar_dark_mode', this.appbar_dark_mode ? 1 : 0 )

        formData.append('auditorium_image', this.auditorium_image)
        formData.append('auditorium_image_sm', this.auditorium_image_sm)

        formData.append('my_project_image', this.my_project_image)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'editEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onImageHomeChange() {
        this.url_home_image = URL.createObjectURL(this.home_image);
      },

      deleteImageHome(){
        this.home_image=null
        this.url_home_image=null
      },

      onAppBarImageChange() {
        this.url_appbar_image = URL.createObjectURL(this.appbar_image);
      },

      deleteAppBarImage(){
        this.appbar_image=null
        this.url_appbar_image=null
      },

      onImageAuditoriumChange() {
        this.url_auditorium_image = URL.createObjectURL(this.auditorium_image);
      },

      deleteImageAuditorium(){
        this.auditorium_image=null
        this.url_auditorium_image=null
      },

      //-------Auditorio SM---------

      onImageAuditoriumSMChange() {
        this.url_auditorium_image_sm = URL.createObjectURL(this.auditorium_image_sm);
      },

      deleteImageAuditoriumSM(){
        this.auditorium_image_sm=null
        this.url_auditorium_image_sm=null
      },

      //-------My Project-----------
      onProjectImageChange() {
        this.url_my_project_image = URL.createObjectURL(this.my_project_image);
      },

      deleteProjectImage(){
        this.my_project_image=null
        this.url_my_project_image=null
      }

    },

    created(){
      // this.getCustomization()
    },
  }
</script>
